import { render, staticRenderFns } from "./Kits.vue?vue&type=template&id=2b4f256a&"
import script from "./Kits.vue?vue&type=script&lang=ts&"
export * from "./Kits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports